var React = require('react');

function Alert (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.2,0.4H4.7C1.8,0.4,0,2.1,0,5.1v7.8c0,2.9,1.7,4.7,4.7,4.7h5.6l3.4,3c0.7,0.6,1.2,0.9,1.8,0.9c0.9,0,1.4-0.6,1.4-1.6\n\tv-2.3h0.4c2.8,0,4.6-1.7,4.6-4.7V5.1C21.9,2.1,20.1,0.3,17.2,0.4z M12,4.7l-0.2,5.6h-1.8L9.9,4.7H12z M11.7,12.9\n\tc-0.2,0.2-0.5,0.3-0.8,0.3s-0.6-0.1-0.8-0.3s-0.3-0.5-0.3-0.8c0-0.3,0.1-0.5,0.3-0.7s0.5-0.3,0.8-0.3s0.6,0.1,0.8,0.3\n\ts0.3,0.5,0.3,0.7C12.1,12.5,12,12.7,11.7,12.9z"}));
}

Alert.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 21.9 21.9","style":{"enableBackground":"new 0 0 21.9 21.9"},"xmlSpace":"preserve"};

module.exports = Alert;

Alert.default = Alert;
